function campaignActionMaterialsDialog () {
  return {
    restrict: 'E',
    templateUrl: '/arts/dialogs/campaign-action-materials/campaign-action-materials-dialog.html?$$REVISION$$'
  }
}

export { campaignActionMaterialsDialog }
